(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lens-customization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lens-customization')) {
    customElements.define(
      'lens-customization',
      class extends HTMLElement {
        connectedCallback() {
          this.packageSelect = this.querySelector('[data-lens-package]');
          this.featureSelect = this.querySelector('[data-lens-feature]');
          this.featureSection = this.querySelector('[data-lens-feature-section]');
          this.packageProperty = this.querySelector('[data-lens-package-property]');
          this.featureProperty = this.querySelector('[data-lens-feature-property]');
          this.prescriptionSection = this.querySelector('[data-prescription-section]');
          this.prescriptionFields = [...this.querySelectorAll('[data-prescription-field]')];
          this.additionalFields = [...this.querySelectorAll('[data-additional-id], [data-additional-quantity], [data-additional-parent]')];
          this.additionalId = this.querySelector('[data-additional-id]');
          this.additionalParent = this.querySelector('[data-additional-parent]');
          this.surcharge = this.querySelector('[data-lens-surcharge]');
          this.error = this.querySelector('[data-lens-error]');
          this.form = document.getElementById(this.dataset.formId);
          this.section = this.closest('.shopify-section');
          this.populateOptions();
          this.packageSelect.value = '';
          this.dataset.frameVariantId = this.form?.querySelector('input[name="id"]')?.value || this.dataset.frameVariantId;
          this.variantAvailable = !this.getAddButton()?.disabled;
          this.onChange = this.handleChange.bind(this);
          this.onSubmit = this.handleSubmit.bind(this);
          this.onVariantUpdate = this.handleVariantUpdate.bind(this);
          this.onVariantSelected = this.handleVariantSelected.bind(this);
          this.addEventListener('change', this.onChange);
          this.form?.addEventListener('submit', this.onSubmit, true);
          this.section?.addEventListener('variant:update', this.onVariantUpdate);
          this.section?.addEventListener('variant:selected', this.onVariantSelected);
          this.updateState();
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.onChange);
          this.form?.removeEventListener('submit', this.onSubmit, true);
          this.section?.removeEventListener('variant:update', this.onVariantUpdate);
          this.section?.removeEventListener('variant:selected', this.onVariantSelected);
        }

        populateOptions() {
          const placeholder = this.dataset.selectPlaceholder;
          const pd = this.querySelector('[data-total-pd]');
          const sphFields = this.querySelectorAll('[data-sph]');
          const cylFields = this.querySelectorAll('[data-cyl]');
          const axisFields = this.querySelectorAll('[data-axis]');

          for (let value = 52; value <= 68; value += 0.5) {
            pd?.add(new Option(value.toFixed(1), value.toFixed(1)));
          }

          for (let step = 60; step >= -60; step -= 1) {
            const value = step / 4;
            const label = value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2);
            sphFields.forEach((select) => select.add(new Option(label, label)));
          }

          for (let step = 0; step >= -16; step -= 1) {
            const label = (step / 4).toFixed(2);
            cylFields.forEach((select) => select.add(new Option(label, label)));
          }

          for (let value = 0; value <= 180; value += 1) {
            const label = value.toString();
            axisFields.forEach((select) => select.add(new Option(label, label)));
          }

          this.querySelectorAll('select').forEach((select) => {
            if (select.options[0]) select.options[0].textContent = placeholder;
          });
        }

        getAddButton() {
          return this.form?.querySelector('[ref="addToCartButton"]');
        }

        getAcceleratedCheckout() {
          return this.form?.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
        }

        handleChange(event) {
          if (event.target.matches('[data-cyl]')) this.updateAxis(event.target.dataset.eye);
          this.updateState();
        }

        handleVariantUpdate(event) {
          const currentProductId = this.form?.closest('product-form-component')?.dataset.productId;
          const eventProductId = event.detail?.data?.productId;
          if (currentProductId && eventProductId && currentProductId !== eventProductId.toString()) return;
          this.variantPending = false;
          this.variantAvailable = Boolean(event.detail?.resource?.available);
          if (event.detail?.resource?.id) {
            this.dataset.frameVariantId = event.detail.resource.id;
            this.additionalParent.value = event.detail.resource.id;
          }
          requestAnimationFrame(() => {
            const result = this.validate();
            if (result.valid) this.showError('');
            this.updatePurchaseControls(result.valid);
          });
        }

        handleVariantSelected() {
          // Do not let the product form queue a bare variant without its lens configuration.
          this.variantPending = true;
          this.updatePurchaseControls();
        }

        handleSubmit(event) {
          const result = this.validate();
          if (result.valid) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showError(result.message);
          result.field?.focus();
        }

        updateState() {
          const packageValue = this.packageSelect.value;
          const hasLenses = packageValue === 'non_prescription' || packageValue === 'prescription';
          const hasPrescription = packageValue === 'prescription';
          const enteringPrescription = hasPrescription && !this.hasPrescription;

          this.featureSection.hidden = !hasLenses;
          this.featureSelect.disabled = !hasLenses;
          if (!hasLenses) this.featureSelect.value = '';
          const standardOption = this.featureSelect.querySelector('option[value="standard_clear"]');
          if (standardOption) {
            standardOption.textContent = hasPrescription ? this.dataset.standardPaidLabel : this.dataset.standardIncludedLabel;
          }

          this.prescriptionSection.hidden = !hasPrescription;
          this.prescriptionFields.forEach((field) => {
            if (!hasPrescription) field.value = '';
            field.disabled = !hasPrescription;
          });

          if (enteringPrescription) {
            this.querySelectorAll('[data-sph], [data-cyl]').forEach((field) => {
              field.value = '0.00';
            });
            this.querySelectorAll('[data-axis]').forEach((field) => {
              field.value = '0';
            });
          }

          this.querySelectorAll('[data-cyl]').forEach((field) => this.updateAxis(field.dataset.eye));
          this.hasPrescription = hasPrescription;
          this.updateLocalizedProperties(hasLenses);
          this.updateAdditionalItem();
          this.updateSurcharge();
          this.updateDisplayedPrice();
          const result = this.validate();
          if (result.valid) this.showError('');
          this.updatePurchaseControls(result.valid);
        }

        updateAxis(eye) {
          const hasPrescription = this.packageSelect.value === 'prescription';
          const cyl = this.querySelector(`[data-cyl][data-eye="${eye}"]`);
          const axis = this.querySelector(`[data-axis][data-eye="${eye}"]`);
          const axisRequired = hasPrescription && cyl?.value !== '' && cyl?.value !== '0.00';
          if (hasPrescription && cyl?.value === '0.00') axis.value = '0';
          else if (!axisRequired) axis.value = '';
          axis.disabled = !axisRequired;
          axis.setAttribute('aria-required', axisRequired ? 'true' : 'false');
        }

        getLensUpgrade() {
          const packageValue = this.packageSelect.value;
          const featureValue = this.featureSelect.value;
          const hasLenses = packageValue === 'non_prescription' || packageValue === 'prescription';
          const included = packageValue === 'non_prescription' && featureValue === 'standard_clear';
          if (!hasLenses || !featureValue || included) return { variantId: '', surcharge: 0, included };

          const selected = this.featureSelect.selectedOptions[0];
          const surcharge = featureValue === 'standard_clear' ? this.dataset.standardPrice : this.dataset.blueLightPrice;
          return { variantId: selected?.dataset.variantId || '', surcharge: Number(surcharge) || 0, included: false };
        }

        updateAdditionalItem() {
          const { variantId } = this.getLensUpgrade();
          const enabled = Boolean(variantId);
          const frameVariantId = this.form?.querySelector('input[name="id"]')?.value || this.dataset.frameVariantId;
          this.additionalId.value = variantId || '';
          this.additionalParent.value = frameVariantId || '';
          this.additionalFields.forEach((field) => {
            field.disabled = !enabled;
          });
        }

        updateLocalizedProperties(hasLenses) {
          const packageOption = this.packageSelect.selectedOptions[0];
          const packageValue = packageOption?.dataset.propertyValue || '';
          this.packageProperty.value = packageValue;
          this.packageProperty.disabled = !packageValue;

          const featureOption = this.featureSelect.selectedOptions[0];
          const featureValue = hasLenses ? featureOption?.dataset.propertyValue || '' : '';
          this.featureProperty.value = featureValue;
          this.featureProperty.disabled = !featureValue;
        }

        updateSurcharge() {
          const value = this.featureSelect.value;
          if (this.getLensUpgrade().included) {
            this.surcharge.textContent = this.dataset.includedMessage;
            this.surcharge.hidden = false;
          } else if (value === 'standard_clear') {
            this.surcharge.textContent = this.dataset.standardSurcharge;
            this.surcharge.hidden = false;
          } else if (value === 'anti_blue') {
            this.surcharge.textContent = this.dataset.blueSurcharge;
            this.surcharge.hidden = false;
          } else {
            this.surcharge.textContent = '';
            this.surcharge.hidden = true;
          }
        }

        updateDisplayedPrice() {
          const { surcharge } = this.getLensUpgrade();

          this.dispatchEvent(
            new CustomEvent('lens:price-change', {
              bubbles: true,
              detail: {
                productId: this.form?.closest('product-form-component')?.dataset.productId,
                surcharge,
              },
            })
          );
        }

        validate() {
          if (this.variantPending) {
            return { valid: false, field: this.packageSelect, message: this.dataset.errorUpdating };
          }
          if (!['non_prescription', 'prescription'].includes(this.packageSelect.value)) {
            return { valid: false, field: this.packageSelect, message: this.dataset.errorPurchase };
          }

          if (!['standard_clear', 'anti_blue'].includes(this.featureSelect.value)) {
            return { valid: false, field: this.featureSelect, message: this.dataset.errorLens };
          }

          const upgrade = this.getLensUpgrade();
          if (!upgrade.included && (!upgrade.variantId || this.featureSelect.selectedOptions[0]?.dataset.available !== 'true')) {
            return { valid: false, field: this.featureSelect, message: this.dataset.errorUnavailable };
          }

          if (this.packageSelect.value !== 'prescription') return { valid: true };

          const pd = this.querySelector('[data-total-pd]');
          if (!pd.value) return { valid: false, field: pd, message: this.dataset.errorPd };

          const incompleteEyeField = [...this.querySelectorAll('[data-sph], [data-cyl]')].find((field) => !field.value);
          if (incompleteEyeField) {
            return { valid: false, field: incompleteEyeField, message: this.dataset.errorEyes };
          }

          const missingAxis = [...this.querySelectorAll('[data-axis]')].find((field) => !field.disabled && !field.value);
          if (missingAxis) return { valid: false, field: missingAxis, message: this.dataset.errorAxis };

          return { valid: true };
        }

        updatePurchaseControls(valid = this.validate().valid) {
          const addButton = this.getAddButton();
          if (addButton) addButton.disabled = !valid || !this.variantAvailable;

          const acceleratedCheckout = this.getAcceleratedCheckout();
          if (acceleratedCheckout) {
            // All remaining packages require lens properties to pass through the cart form.
            acceleratedCheckout.hidden = true;
          }
        }

        showError(message) {
          this.error.textContent = message;
          this.error.hidden = !message;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sunglens-style-entry"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-sg-entry]');
    if (!link) return;
    try { sessionStorage.setItem('sunglens-style-product', link.closest('[data-sg-product]').dataset.sgProduct); } catch {}
    const variant = new URL(location.href).searchParams.get('variant');
    if (variant) { const target = new URL(link.href); target.searchParams.set('variant', variant); link.href = target.href; }
  });
  } catch(e) { console.error(e); }
})();

})();
